<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <cargas-bdgd-data-table :items="items" :loading="loading" @rechargeTable="getCargasBdgds" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CargasBdgdsService from '@/services/CargasBdgdsService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    components: {
      CargasBdgdDataTable: () => import('@/components/perdas-tecnicas/carregar-bdgd/CargasBdgdDataTable')
    },
    mixins: [refreshDataMixins],
    data: () => ({
      items: [],
      loading: false
    }),
    created() {
      this.refreshData(this.getCargasBdgds);
    },
    methods: {
      getCargasBdgds() {
        this.loading = true;
        CargasBdgdsService.getCargas()
          .then((responseData) => (this.items = responseData))
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
